import userApi from '../api/user-api';
import storageUtils from '../utils/storage-session-utils';

const login = async (authen) => {
    const resp = await userApi.login(authen);
    if (resp.status !== 'SUCCESS') {
        storageUtils.removeToken();
        throw resp.responseMsgTh;
    }
    storageUtils.setToken(resp.accessToken);
    return resp;
}

const authenService = {
    login
}

export default authenService;